import styled from 'styled-components';

export const DwtcVirtualAssetsIntroWrapper = styled.section`
  padding-top: 80px;
  padding-bottom: 63px;
  background-color: #fff;
  @media (max-width: 992px) {
    padding-top: 30px;
    padding-bottom: 30px;
  }
`;
export const DwtcVirtualAssetsIntroContainer = styled.div`
  max-width: 1120px;
  margin: 0px auto;
  position: relative;
  @media (max-width: 1199px) {
    max-width: 100%;
    padding: 0px 15px;
  }
`;
export const DwtcVirtualAssetsIntroBody = styled.div``;
export const DwtcVirtualAssetsIntroTitleText = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 32px;
  @media (max-width: 992px) {
    flex-direction: column;
    column-gap: 0px;
    row-gap: 15px;
  }
`;
export const DwtcVirtualAssetsIntroTitle = styled.h2`
  width: 352px;
  font-size: 30px;
  line-height: 42px;
  font-weight: 400;
  color: #000;
  margin: 0px;
  @media (max-width: 1199px) {
    font-size: 22px;
    line-height: 38px;
  }
  @media (max-width: 992px) {
    width: 100%;
  }
  @media (max-width: 576px) {
    font-size: 20px;
    line-height: 32px;
  }
`;
export const DwtcVirtualAssetsIntroText = styled.div`
  max-width: 736px;
  display: flex;
  flex-direction: row;
  column-gap: 32px;
  &[dir='ltr'] {
    text-align: left;
  }
  &[dir='rtl'] {
    text-align: right;
  }
  p {
    margin: 0px !important;
    padding: 0px !important;
    padding-top: 15px;
    color: #898989;
    font-size: 14px;
    line-height: 20px;
    max-width: 352px;
    @media (max-width: 992px) {
      max-width: 100%;
    }
  }
  @media (max-width: 992px) {
    max-width: 100%;
  }
  @media (max-width: 767px) {
    flex-direction: column;
    row-gap: 15px;
  }
`;
export const DwtcVirtualAssetsIntroAccordion = styled.div`
  margin-top: 46px;
  border: 1px solid #ebebeb;
  overflow: hidden;
  .intro_div {
    position: relative;
    min-height: 460px;
  }
  @media (max-width: 992px) {
    margin-top: 25px;
  }
`;
export const DwtcVirtualAssetsVaraImage = styled.div`
  width: 100%;
  height: 100%;
  img {
    min-height: 288px;
    object-fit: cover;
    @media(max-width:992px){
      min-height: 200px;
    }
  }
`;
export const DwtcVirtualAssetsIntroAccordionItem = styled.div`
  padding-top: 30px;
  padding-right: 30px;
  padding-bottom: 30px;
  padding-left: 30px;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: absolute;
  top: calc(100% - 179px);
  transition: top 0.3s ease-in-out 0s;
  background-color: #fff;
  &.acc-up {
    position: absolute;
    top: 0px;
    transition: top 0.3s ease-in-out 0s;
    width: 100%;
    height: 100%;
  }
  @media (max-width: 992px) {
    top: calc(100% - 270px);
    padding-top: 25px;
    padding-bottom: 25px;
    padding-left: 20px;
    padding-right: 20px;
    width: 100%;
  }
`;

export const DwtcVirtualAssetsIntroAccordionButton = styled.button`
  outline: none;
  border: none;
  background-color: transparent;
  font-size: 16px;
  line-height: 32px;
  color: #000;
  width: 100%;
  display: flex;
  flex-direction: row;
  column-gap: 20px;
  font-weight: 600;
  justify-content: space-between;
  padding: 0px;
  align-items: start;

  &[dir='ltr'] {
    font-family: DINRegular;
    text-align: left;
  }

  &[dir='rtl'] {
    text-align: right;
    font-family: GESSTwoDWTCLight,sans-serif;
  }
  p {
    font-size: 16px;
    font-weight: 400;
    color: #4a4a4a;
    font-family: DINRegular;
    letter-spacing: 1.29px;
    line-height: 20px;
    margin: 0px;
    padding-top: 30px;

    &[dir='rtl'] {
      font-family: GESSTwoDWTCLight,sans-serif;
    }

    @media (max-width: 992px) {
      letter-spacing: 0px;
      padding-top: 15px;
    }
  }

  .button-text {
    color: #000;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    cursor: pointer;

    span {
      font-size: 10px;
      line-height: 10px;
      font-weight: 400;
      text-transform: uppercase;
      color: #000;
      &[dir='ltr'] {
        letter-spacing: 1.82px;
      }

    }
    h4 {
      font-size: 20px;
      line-height: 28px;
      font-weight: 400;
      margin: 0px;
      padding: 0px;
      color: #000;
      font-family: inherit;

      &[dir='ltr'] {
        font-family: 'LibreBaskervilleRegular';
        text-align: left;
      }
      
      @media (max-width: 992px) {
        font-size: 18px;
        line-height: 26px;
      }
    }
  }

  .arrow {
    border: solid black;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 4px;
    margin-top: 30px;
  }
  .arrow-up {
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
  }
  .arrow-down {
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
  }
  @media (max-width: 992px) {
    line-height: 22px;
    font-size: 15px;
  }
`;
export const DwtcVirtualAssetsIntroAccordionBody = styled.div`
  padding-top: 35px;
  display: flex;
  flex-direction: column;
  row-gap: 35px;
  overflow-y: auto;
  &[dir='ltr'] {
    padding-right: 40px;
  }
  &[dir='rtl'] {
    padding-left: 40px;
  }
  p {
    margin: 0px;
    font-size: 14px;
    line-height: 20px;
    font-size: 14px;
    font-weight: 400;
    strong {
      font-size: 16px;
      font-weight: 400;
      color: #4a4a4a;
      font-family: DINRegular;
      letter-spacing: 1.29px;
      @media (max-width: 992px) {
        letter-spacing: 0px;
      }
    }
  }
  @media (max-width: 992px) {
    padding-top: 15px;
    row-gap: 15px;
    &[dir='ltr'] {
      padding-right: 0px;
    }
    &[dir='rtl'] {
      padding-left: 0px;
    }
  }
`;
export const DwtcVirtualAssetsIntroLinkButton = styled.div`
  padding-top: 40px;
  @media (max-width: 992px) {
    padding-top: 30px;
  }
  a {
    min-width: 148px;
  }
`;
